import React, { Fragment, Component } from 'react';
import AdminShoutbox from '../../admin/AdminShoutbox';
import AdminNavbar from '../../admin/AdminNavbar';
import { Container } from '../../admin/Styles';

class AdminShoutboxModerationPage extends Component {
  renderContent = () => {
    return (
      <Fragment>
        <AdminShoutbox />
      </Fragment>
    );
  };

  render() {
    return (
      <Container>
        <AdminNavbar />
        <h2>Shoutbox moderation</h2>
        {this.renderContent()}
      </Container>
    );
  }
}

export default AdminShoutboxModerationPage;
